import {
  Component,
  inject,
  computed,
  ChangeDetectionStrategy,
} from '@angular/core';
import { IAppConfig, INavItem } from '@tnq/shared/types';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { DividerComponent, NavListComponent } from '../../components';
import { AuthService, CurrentUserService } from '@tnq/shared/core';
import { CONFIG } from '@tnq/shared/config';
import {
  SuiIconButtonComponent,
  SuiIconComponent,
  SuiTooltipDirective,
} from '@stride-ui/components';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeService } from '../../services';

@Component({
  selector: 'tnq-nav-layout',
  imports: [
    SuiIconButtonComponent,
    SuiIconComponent,
    SuiTooltipDirective,
    TranslateModule,
    RouterOutlet,
    RouterModule,
    NavListComponent,
    DividerComponent,
  ],
  templateUrl: './nav-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './nav-layout.component.scss',
})
export class NavLayoutComponent {
  readonly breakpointObserver = inject(BreakpointObserver);
  readonly authService = inject(AuthService);
  readonly router = inject(Router);
  readonly currentUserService = inject(CurrentUserService);
  readonly themeService = inject(ThemeService);
  readonly config = inject<IAppConfig>(CONFIG);

  currentUser = this.currentUserService.currentUser;
  portal = '';
  isNarrowDisplay = false;

  readonly navList = computed<INavItem[]>(() => {
    const roles = this.currentUser()?.roles ?? [];
    return (this.config.navList ?? []).filter(
      (item) =>
        !item.roles?.length || item.roles.some((r) => roles.includes(r)),
    );
  });

  constructor() {
    this.portal = this.config.portal || '';
    this.breakpointObserver
      .observe(['(max-width: 720px)'])
      .subscribe((result: BreakpointState) => {
        this.isNarrowDisplay = result.matches;
      });
  }

  toggleNavDisplaySize(): void {
    this.isNarrowDisplay = !this.isNarrowDisplay;
  }

  navigateTo(target: string): void {
    this.router.navigate([target]);
  }

  logout(): void {
    this.authService.logout$();
    this.router.navigate(['/auth/login']);
  }
}
